import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Combos/getUbicacionesVacias`, method: 'POST', body: values, token: token})
}
